import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueLogger from 'vuejs-logger';
import { OAuth, IeBlocker } from '@nswdoe/doe-ui-core';
import Env from './plugins/env';
import {getConfig} from '@/utils/config';

let renderComponent, renderProps;

const isProduction = process.env.NODE_ENV === 'production';

const loggerOptions = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: false,
  separator: '|',
  showConsoleColors: true
};

Vue.use(VueLogger, loggerOptions);
Vue.use(Env);

if (IeBlocker.isIe()) {
  // block
  renderComponent = IeBlocker;
  renderProps = {
    props: {
      block: true,
      appName: "EdPush"
    }
  };

  initApp();
} else {
  // load app normally
  renderComponent = App
  renderProps = {};

  Vue.config.productionTip = false;

  // Global event bus
  Vue.prototype.$eventHub = new Vue();

  Vue.use(VueAxios, axios);

  if (isProduction) {
    // make sure openshift env variables are fetched first
    Vue.prototype.$Env.init('/envmetadata')
    .then(function() {
      initApp();
    });
  } else {
    // use .env.local
    initApp();
  }
}

function initApp() {
  // DoE OAuth config options.
  // let responseType = getConfig('VUE_APP_OAUTH_PKCE') === 'true' ? 'code' : 'token id_token';

  const authOptions = {
    forceProdMode: true,
    router: router,
    secureApp: true,
    authoriseUri: getConfig('VUE_APP_OAUTH_URL'),
    logoutUri: getConfig('VUE_APP_OAUTH_LOGOUT_URL'),
    tokenUri: getConfig('VUE_APP_OAUTH_TOKEN_URL'),
    clientSecret: getConfig('VUE_APP_OAUTH_CLIENT_SECRET'),
    // authorise url params
    params: {
      client_id: getConfig('VUE_APP_OAUTH_CLIENT_ID'),
      redirect_uri: getConfig('VUE_APP_OAUTH_REDIRECT_URL'),
      scope: encodeURIComponent('openid')
    },
    pkce: getConfig("VUE_APP_OAUTH_PKCE")
  };
  Vue.use(OAuth, authOptions);

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(renderComponent, renderProps)
  }).$mount('#app')
}
